import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const Home = () => {
    useEffect(() => {
        // Initialize owl carousel
        if (window.jQuery) {
            const $ = window.jQuery;

            // Initialize owl carousel
            $(".banner-carousel").owlCarousel({
                loop: false,
                margin: 10,
                nav: false,
                dots: false,
                autoplay: false,
                // autoplayTimeout: 5000,
                items: 1,
                // responsive: {
                //     0: { items: 1 },
                //     600: { items: 1 },
                //     1000: { items: 1 }
                // }
            });

            // Initialize project carousel
            $(".project-style1-carousel").owlCarousel({
                loop: true,
                margin: 30,
                nav: true,
                dots: false,
                autoplay: true,
                autoplayTimeout: 6000,
                items: 1,
                responsive: {
                    0: { items: 1 },
                    600: { items: 1 },
                    768: { items: 1 },
                    992: { items: 1 },
                    1200: { items: 1 }
                }
            });

            // Initialize testimonials carousel
            $(".testimonials-carousel_1").owlCarousel({
                loop: true,
                margin: 30,
                nav: false,
                dots: false,
                autoplay: true,
                autoplayTimeout: 6000,
                items: 1,
                responsive: {
                    0: { items: 1 },
                    600: { items: 1 },
                    768: { items: 1 },
                    992: { items: 1 },
                    1200: { items: 1 }
                }
            });

            // Initialize wow animations
            if (window.WOW) {
                new window.WOW().init();
            }

            // Fact Counter
            if ($('.count-box').length) {
                $('.count-box').appear(function () {
                    var $t = $(this),
                        n = $t.find(".count-text").attr("data-stop"),
                        r = parseInt($t.find(".count-text").attr("data-speed"), 10);

                    if (!$t.hasClass("counted")) {
                        $t.addClass("counted");
                        $({
                            countNum: $t.find(".count-text").text()
                        }).animate({
                            countNum: n
                        }, {
                            duration: r,
                            easing: "linear",
                            step: function () {
                                $t.find(".count-text").text(Math.floor(this.countNum));
                            },
                            complete: function () {
                                $t.find(".count-text").text(this.countNum);
                            }
                        });
                    }
                }, {
                    accY: 0
                });
            }

            // Accordion Box
            if ($('.accordion-box').length) {
                $('.accordion-box').on('click', '.acc-btn', function () {
                    var outerBox = $(this).parents('.accordion-box');
                    var target = $(this).parents('.accordion');

                    if ($(this).hasClass('active') !== true) {
                        $(outerBox).find('.accordion .acc-btn').removeClass('active');
                    }

                    if ($(this).next('.acc-content').is(':visible')) {
                        return false;
                    } else {
                        $(this).addClass('active');
                        $(outerBox).children('.accordion').removeClass('active-block');
                        $(outerBox).find('.accordion').children('.acc-content').slideUp(300);
                        target.addClass('active-block');
                        $(this).next('.acc-content').slideDown(300);
                    }
                });
            }
        }
    }, []);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        getProjects();
        getNotifications();
    }, []);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [loading, setLoading] = useState(false);
    const [projectloading, setProjectloading] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        // location: "",
        serviceName: "Home",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // stop page reload

        try {
            setLoading(true);

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}services`, // 👈 endpoint
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            setFormData({
                name: "",
                email: "",
                mobile: "",
                // location: "",
                serviceName: "",
                message: "",
            });

        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const [showAll, setShowAll] = useState(false);
    const [projectDetails, setProjectDetails] = useState([]);
    // Ensure projectDetails is an array before using array methods
    const visibleProjects = Array.isArray(projectDetails)
        ? (showAll ? projectDetails : projectDetails.slice(0, 6))
        : [];

    const urlImage = process.env.REACT_APP_IMAGE_BASE_URL;


    const getProjects = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}projects`
            );
            setProjectDetails(response.data);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setProjectloading(false);
        }
    }


    const [slidesList, setSlidesList] = useState([]);
    const getNotifications = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}notifications`
            );
            // Ensure slidesList is always an array
            const data = Array.isArray(response.data) ? response.data : (response.data?.data || []);
            setSlidesList(data);
            // console.log(response.data, 'dsadadsdsdasdasasd');
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setProjectloading(false);
        }
    }

    const [index, setIndex] = useState(0);

    // Reset index when API data changes
    useEffect(() => {
        if (slidesList.length > 0) {
            setIndex(0);
        }
    }, [slidesList]);

    const nextSlide = () => {
        setIndex((prev) => (prev + 1) % slidesList.length);
    };

    const prevSlide = () => {
        setIndex((prev) => (prev - 1 + slidesList.length) % slidesList.length);
    };

    // ✅ Autoplay every 10 seconds
    useEffect(() => {
        if (!slidesList.length) return;

        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % slidesList.length);
        }, 8000); // 10 seconds

        return () => clearInterval(interval);
    }, [slidesList]);


    const formatDate = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            // hour: "2-digit",
            // minute: "2-digit",
            // hour12: true
        });
    };

    return (
        <>

            {/* banner section */}
            <section className="home-mainsection">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="main-leftSection" >
                                <h2 className="mainsection-header">Committed to <br /> Smart <span style={{ color: "#fd6d0a" }}>Construction</span> <br /> Planning & Approvals</h2>
                                <p className="mainsection-subheader" id="servicessection">We help homeowners, builders, and developers plan, approve, and execute projects with confidence and compliance.</p>
                                <div className="mainsection-btnsection">
                                    <NavLink
                                        to="#servicessection"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            document.getElementById("servicessection").scrollIntoView({
                                                behavior: "smooth",
                                            });
                                        }}
                                    >
                                        <p className="mainsection-bt1">Our Services</p>
                                    </NavLink>
                                    <NavLink to="/About-Us"><p className="mainsection-bt1 mainsection-bt2">Discover</p></NavLink>
                                </div>
                            </div>
                        </div>

                        {slidesList?.length > 0 && (
                            <div className="col-md-6">
                                <div className="announcementSlider">
                                    <button className="arrow left" onClick={prevSlide}>
                                        ❮
                                    </button>

                                    <div className="slideContent">
                                        <h2>{slidesList[index]?.title}</h2>
                                        {/* <p className="date">{slidesList[index]?.end_date}</p> */}
                                        <p className="date">End at {formatDate(slidesList[index]?.end_date)}.</p>
                                        <p className="desc">{slidesList[index]?.message}</p>

                                        <div className="dots">
                                            {slidesList?.map((_, i) => (
                                                <span
                                                    key={i}
                                                    className={i === index ? "dot active" : "dot"}
                                                    onClick={() => setIndex(i)}
                                                />
                                            ))}
                                        </div>
                                    </div>

                                    <button className="arrow arrow2 right" onClick={nextSlide}>
                                        ❯
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="homemain-slideservices">
                        <div className="row">
                            <div className="col-md-2">
                                <NavLink to="/Architecture">
                                    <div className="services-boxsection">
                                        <img src="/assets/images/services/icons/Architecture.png" alt="Architecture" className="services-boxsection-img" />
                                        <h3 className="services-boxsection-head">Architecture</h3>
                                        <p className="services-boxsection-txt">Innovative <span>Bud</span> Design</p>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-md-2">
                                <NavLink to="/Building">
                                    <div className="services-boxsection">
                                        <img src="/assets/images/services/icons/Building.png" alt="Building" className="services-boxsection-img" />
                                        <h3 className="services-boxsection-head">Building</h3>
                                        <p className="services-boxsection-txt"><span>Bud</span>get Friendly Construction</p>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-md-2">
                                <NavLink to="/Layout">
                                    <div className="services-boxsection">
                                        <img src="/assets/images/services/icons/Layout.png" alt="Layout" className="services-boxsection-img" />
                                        <h3 className="services-boxsection-head">Layout</h3>
                                        <p className="services-boxsection-txt">Smart Layouts with <span>Bud</span> Standards</p>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-md-2">
                                <NavLink to="/TDR">
                                    <div className="services-boxsection">
                                        <img src="/assets/images/services/icons/TDR.png" alt="TDR" className="services-boxsection-img" />
                                        <h3 className="services-boxsection-head">TDR</h3>
                                        <p className="services-boxsection-txt">Efficient TDR Facilitation with <span>Bud</span></p>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-md-2">
                                <NavLink to="/BPS">
                                    <div className="services-boxsection">
                                        <img src="/assets/images/services/icons/BPS.png" alt="BPS" className="services-boxsection-img" />
                                        <h3 className="services-boxsection-head">BPS</h3>
                                        <p className="services-boxsection-txt">Building Penalization Scheme</p>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-md-2">
                                <NavLink to="/LRS">
                                    <div className="services-boxsection">
                                        <img src="/assets/images/services/icons/LRS.png" alt="LRS" className="services-boxsection-img" />
                                        <h3 className="services-boxsection-head">LRS</h3>
                                        <p className="services-boxsection-txt">Layout Regularization Scheme</p>
                                    </div>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </section>




            <div id="servicessection"></div>


            {/* about section */}
            <section className="about-style1-area" >
                <div className="shape1 wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
                    <img className="float-bob-y" src="assets/images/shape/thm-shape-2.png" alt="" />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6">
                            <div className="about-style1__image1">
                                <div className="shape2 wow zoomIn" data-wow-delay="100ms" data-wow-duration="2500ms">
                                    <img className="rotate-me" src="assets/images/shape/thm-shape-3.png" alt="" />
                                </div>
                                <div className="inner wow slideInLeft" style={{ animation: 'none' }}>
                                    <img src="assets/images/about/about-style1.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="about-style1__content">
                                <div className="sec-title">
                                    <div className="sub-title">
                                        <p>ABOUT BUDPLAN</p>
                                    </div>
                                    <h2>Smart Construction Planning for Modern Developments</h2>
                                </div>
                                <div className="inner-content">
                                    <p>BUDPLAN is a professional construction consultancy delivering architecture, planning,
                                        and approval services with precision and compliance. We support residential and
                                        commercial projects from concept to execution.
                                    </p>
                                    <ul>
                                        <li className="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
                                            <div className="icon">
                                                <span className="flaticon-checked" />
                                            </div>
                                            <div className="text">
                                                <h3>Architecture & Planning</h3>
                                                <p>Functional designs, accurate drawings, and practical planning tailored to project needs.</p>
                                            </div>
                                        </li>
                                        <li className="style2 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                                            <div className="icon">
                                                <span className="flaticon-checked" />
                                            </div>
                                            <div className="text">
                                                <h3>Approvals & Compliance</h3>
                                                <p>Expert handling of building approvals, layouts, TDR services, and statutory documentation.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="testmonialandfaq-mainsection">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="testmonial-subsection">
                                <div className="testimonials-style1__content">
                                    <div className="sec-title">
                                        <img className="icon-home" src="assets/images/faq.png" alt="" />
                                        <div className="sub-title">
                                            <p>Testimonials</p>
                                        </div>
                                        <h2>What Our Client Say<br /> About BUDPLAN</h2>
                                    </div>
                                    <div className="testimonials-carousel_1 owl-theme owl-carousel">

                                        <div className="single-testimonials-style1">
                                            <div className="text">
                                                <p>"Working with BUDPLAN made our construction process smooth and stress-free.
                                                    Their planning, approvals support, and attention to compliance helped us
                                                    complete the project on time."
                                                </p>
                                            </div>
                                            <div className="client-info">
                                                <div className="img-box">
                                                    <img src="assets/images/testimonial/testimonial-v1-1.jpg" alt="Amelia Anna" />
                                                </div>
                                                <div className="title-box">
                                                    <h3>Residential Project Owner</h3>

                                                </div>
                                            </div>
                                        </div>


                                        <div className="single-testimonials-style1">
                                            <div className="text">
                                                <p>"BudPlan made our construction planning incredibly simple and efficient. Their platform helped us visualize layouts, manage approvals, and streamline the entire building process. The team is highly professional and responsive. I would definitely recommend BudPlan to anyone planning a construction project."</p>
                                            </div>
                                            <div className="client-info">
                                                <div className="img-box">
                                                    <img src="assets/images/testimonial/testimonial-v1-1.jpg" alt="Client Name" />
                                                </div>
                                                <div className="title-box">
                                                    <h3>Property Developer</h3>
                                                    {/* <span>Property Developer</span> */}
                                                </div>
                                            </div>
                                        </div>


                                        <div className="single-testimonials-style1">
                                            <div className="text">
                                                <p>"Working with BudPlan was a great experience. From architectural planning to project guidance, everything was handled smoothly. The designs were modern, practical, and exactly what we wanted for our dream home. Their platform truly makes construction planning easier."</p>
                                            </div>
                                            <div className="client-info">
                                                <div className="img-box">
                                                    <img src="assets/images/testimonial/testimonial-v1-1.jpg" alt="Another Client" />
                                                </div>
                                                <div className="title-box">
                                                    <h3>Home Owner</h3>
                                                    {/* <span>Home Owner</span> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="faq-sebsection">
                                <div className="faq-style1__content">
                                    <div className="sec-title">
                                        <img className="icon-home icon-home1" src="assets/images/Testimonials.png" alt="" />
                                        <div className="sub-title">
                                            <p>FREQUENT QUESTIONS</p>
                                        </div>
                                        <h2>Frequently Asked Questions</h2>
                                    </div>
                                    <div className="inner-content">
                                        <div className="text">
                                            <p>Find quick answers to common questions about our construction consultancy
                                                services, approvals process, and project support.
                                            </p>
                                        </div>
                                        <ul className="accordion-box">
                                            <li className="accordion block active-block">
                                                <div className="acc-btn active">
                                                    <div className="icon-outer"><i className="flaticon-plus" /></div>
                                                    <h3><b>Q.</b> How does BUDPLAN work?</h3>
                                                </div>
                                                <div className="acc-content current">
                                                    <p>We begin with a consultation to understand your project requirements, followed
                                                        by planning, approvals, and execution support until completion.
                                                    </p>
                                                </div>
                                            </li>
                                            <li className="accordion block">
                                                <div className="acc-btn">
                                                    <div className="icon-outer"><i className="flaticon-plus" /></div>
                                                    <h3><b>Q.</b> How does your pricing work?</h3>
                                                </div>
                                                <div className="acc-content">
                                                    <p>Our pricing depends on project scope, services required, and approval complexity.
                                                        We provide transparent and detailed quotations.
                                                    </p>
                                                </div>
                                            </li>
                                            <li className="accordion block">
                                                <div className="acc-btn">
                                                    <div className="icon-outer"><i className="flaticon-plus" /></div>
                                                    <h3><b>Q.</b> How can I take your service?</h3>
                                                </div>
                                                <div className="acc-content">
                                                    <p>You can contact us through phone, email, or our website form to schedule a
                                                        consultation with our experts.
                                                    </p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="working-process-area">
                <div className="shape1 wow slideInUp" data-wow-delay="100ms" data-wow-duration="5000ms" style={{ backgroundImage: 'url(assets/images/shape/working-process-shape-1.png)' }} />
                <div className="shape2 wow slideInLeft" data-wow-delay="100ms" data-wow-duration="3500ms">
                    <img className="float-bob-y" src="assets/images/shape/working-process-shape-2.png" alt="" />
                </div>
                <div className="shape3 wow slideInDown" data-wow-delay="100ms" data-wow-duration="4500ms">
                    <img className="float-bob-x" src="assets/images/shape/working-process-shape-3.png" alt="" />
                </div>
                <div className="shape4 wow" >
                    <img className="zoom-fade" src="assets/images/shape/working-process-shape-4.png" alt="" />
                </div>
                <div className="container">
                    <div className="sec-title text-center">
                        <div className="sub-title">
                            <p>Working Plan</p>
                        </div>
                        <h2>BUDPLAN Working Process</h2>
                    </div>
                    <div className="row">
                        <div className="col-xl-12">
                            <ul className="working-process-box">
                                {/*Start Working process Single*/}
                                <li className="single-working-process wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                                    <div className="arrow-box"><img src="assets/images/shape/arrow.png" alt="" /></div>
                                    <div className="img-holder">
                                        <img src="assets/images/resources/working-process-1.png" alt="" />
                                        <div className="count" />
                                    </div>
                                    <div className="text-holder">
                                        <h3>Consultation & Requirement Review</h3>
                                        <p>Share your project details with our team. We understand your requirements,
                                            site conditions, and compliance needs.
                                        </p>
                                    </div>
                                </li>
                                {/*End Working process Single*/}
                                {/*Start Working process Single*/}
                                <li className="single-working-process wow fadeInUp" data-wow-delay="100ms" data-wow-duration="1500ms">
                                    <div className="arrow-box"><img src="assets/images/shape/arrow-2.png" alt="" /></div>
                                    <div className="img-holder">
                                        <img src="assets/images/resources/working-process-2.png" alt="" />
                                        <div className="count" />
                                    </div>
                                    <div className="text-holder">
                                        <h3>Planning & Approvals</h3>
                                        <p>Our experts prepare designs, drawings, and handle approvals, layouts,
                                            TDR services, and documentation.
                                        </p>
                                    </div>
                                </li>
                                {/*End Working process Single*/}
                                {/*Start Working process Single*/}
                                <li className="single-working-process wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                                    <div className="img-holder">
                                        <img src="assets/images/resources/working-process-3.png" alt="" />
                                        <div className="count" />
                                    </div>
                                    <div className="text-holder">
                                        <h3>Execution Support & Completion</h3>
                                        <p>We coordinate with stakeholders and support execution to ensure smooth,
                                            timely, and compliant project completion.
                                        </p>
                                    </div>
                                </li>
                                {/*End Working process Single*/}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="fact-counter-area">
                <div className="pattern-bg" style={{ backgroundImage: 'url(assets/images/pattern/thm-pattern-1.png)' }} />
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="fact-counter_box">
                                <ul className="clearfix">
                                    {/*Start Single Fact Counter*/}
                                    <li className="single-fact-counter wow slideInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                                        <div className="icon">
                                            <span className="flaticon-complete" />
                                        </div>
                                        <div className="outer-box">
                                            <div className="count-outer count-box d-flex">
                                                <span className="count-text" data-speed={3000} data-stop={90}>0</span>
                                                <span>+</span>
                                            </div>
                                            <div className="title">
                                                <h6>Completed Projects</h6>
                                            </div>
                                        </div>
                                    </li>
                                    {/*End Single Fact Counter*/}
                                    {/*Start Single Fact Counter*/}
                                    <li className="single-fact-counter wow slideInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                                        <div className="icon">
                                            <span className="flaticon-like" />
                                        </div>
                                        <div className="outer-box">
                                            <div className="count-outer count-box d-flex">
                                                <span className="count-text" data-speed={3000} data-stop={216}>0</span>
                                                <span>+</span>
                                            </div>
                                            <div className="title">
                                                <h6>Happy Clients</h6>
                                            </div>
                                        </div>
                                    </li>
                                    {/*End Single Fact Counter*/}
                                    {/*Start Single Fact Counter*/}
                                    <li className="single-fact-counter wow slideInUp" data-wow-delay="100ms" data-wow-duration="1500ms">
                                        <div className="icon">
                                            <span className="flaticon-sharing" />
                                        </div>
                                        <div className="outer-box">
                                            <div className="count-outer count-box d-flex">
                                                <span className="count-text" data-speed={3000} data-stop={35}>0</span>
                                                <span>+</span>
                                            </div>
                                            <div className="title">
                                                <h6>Expert Team</h6>
                                            </div>
                                        </div>
                                    </li>
                                    {/*End Single Fact Counter*/}
                                    {/*Start Single Fact Counter*/}
                                    <li className="single-fact-counter wow slideInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                                        <div className="icon">
                                            <span className="flaticon-medal" />
                                        </div>
                                        <div className="outer-box">
                                            <div className="count-outer count-box d-flex">
                                                <span className="count-text" data-speed={3000} data-stop={10}>0</span>
                                                <span>+</span>
                                            </div>
                                            <div className="title">
                                                <h6>Years of Industry</h6>
                                            </div>
                                        </div>
                                    </li>
                                    {/*End Single Fact Counter*/}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="team-style1-area">
                {/*  */}
            </section>

            <section className="team-style1-area">
                <div className="container">
                    <div className="sec-title text-center">
                        <div className="sub-title">
                            <p>Smart Team</p>
                        </div>
                        <h2>WORKING PARTNERS</h2>
                    </div>
                    <div className="home-teamsec">
                        <div className="row justify-content-center">
                            <div className="col-md-4">
                                <div className="home-teamsec-box">
                                    <h3 className="home-teamsec-boxhead">AS ASSOCIATES</h3>
                                    <p className="home-teamsec-boxsubhead">BHULOK ANAND</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="home-teamsec-box home-teamsec-box1">
                                    <h3 className="home-teamsec-boxhead">KP INFRA</h3>
                                    <p className="home-teamsec-boxsubhead">GANGINENI MAHESH KUMAR</p>
                                </div>
                            </div>
                            {/* <div className="col-md-4">
                                <div className="home-teamsec-box home-teamsec-box1">
                                    <h3 className="home-teamsec-boxhead">Christian Bale</h3>
                                    <p className="home-teamsec-boxsubhead">Founder & CEO</p>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

            <section className="contact-style1-area">
                <div className="shape1">
                    <img className="paroller-2" src="assets/images/shape/contact-style1-shape-1.png" alt="" />
                </div>
                <div className="shape2">
                    <img className="zoom-fade" src="assets/images/shape/contact-style1-shape-2.png" alt="" />
                </div>
                <div className="shape3 float-bob-y" style={{ backgroundImage: 'url(assets/images/shape/contact-style1-shape-3.png)' }} />
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4">
                            <div className="contact-style1__image wow slideInLeft" >
                                <img src="assets/images/resources/house-1.png" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-8">
                            <div className="contact-form-box1">
                                <div className="top-title">
                                    <h2>Need Mordern BUDPLAN <br /> Service Help?</h2>
                                </div>
                                <form
                                    id="contact-form"
                                    name="contact_form"
                                    className="default-form1"
                                    onSubmit={handleSubmit}
                                >
                                    <div className="row">
                                        <div className="col-xl-4">
                                            <div className="input-box">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    placeholder="Name"
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-xl-4">
                                            <div className="input-box">
                                                <input
                                                    type="text"
                                                    name="mobile"
                                                    value={formData.mobile}
                                                    onChange={handleChange}
                                                    placeholder="mobile"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-xl-4">
                                            <div className="button-box">
                                                <button className="btn-one style2" type="submit">
                                                    <span className="txt">Submit Now</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {
                slidesList?.length > 0 && (
                    <div className="OurWorks-mainsection">
                        <div className="container">
                            <h3 className="OurWorks-mainsection-sub">Our Works</h3>
                            <h2 className="OurWorks-mainsection-head">Explore Our <br /> Latest
                                Projects</h2>
                            <div className="row">

                                {/* {projectDetails.map((project, index) => ( */}
                                {visibleProjects.map((project, index) => (
                                    <div className="col-md-4" key={index}>
                                        <div className="OurWorks-boxSec">
                                            <img
                                                src={`${urlImage}${project?.image_path}`}
                                                alt={project?.title}
                                                className="OurWorks-im"
                                            />
                                            <div className="OurWorks-boxSec2" style={{ flexDirection: 'column' }}>
                                                <p className="OurWorks-boxSec2Head">{project?.title}</p>
                                                <p className="OurWorks-boxSec2txt">{project?.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {projectDetails.length > 6 && (
                                <div className="text-center mt-4">
                                    <button
                                        className="btn viewBt"
                                        onClick={() => setShowAll(!showAll)}
                                    >
                                        {showAll ? "Hide" : "View All"}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )
            }


            {/*Start Blog Style1 Area*/}
            <section className="blog-style1-area">
                <div className="container">
                    <div className="sec-title text-center">
                        <div className="sub-title">
                            <p>SMART INSIGHTS</p>
                        </div>
                        <h2>Stay Updated with <br />
                            BUDPLAN News
                        </h2>
                    </div>
                    <div className="row text-right-rtl">
                        {/*Start Single blog Style1*/}
                        <div className="col-xl-4 col-lg-4">
                            <div className="single-blog-style1 wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                                <div className="img-holder">
                                    <div className="inner">
                                        <img src="assets/images/blog/blog-v1-1.jpg" alt="" />
                                        <div className="date-box">
                                            <div className="shape-bg" style={{ backgroundImage: 'url(assets/images/shape/blog-shape-1.png)' }} />
                                            <h5>07 Dec</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-holder">
                                    <ul className="meta-info">
                                        <li><a>CONSTRUCTION</a></li>
                                        <li><a>ADMIN</a></li>
                                    </ul>
                                    <h3 className="blog-title">
                                        <a href="blog-single.html">Essential Planning Tips for Residential Projects</a>
                                    </h3>
                                    <div className="text">
                                        <p>Key considerations for planning approvals, layout design, and compliance
                                            before starting residential construction.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*End Single blog Style1*/}
                        {/*Start Single blog Style1*/}
                        <div className="col-xl-4 col-lg-4">
                            <div className="single-blog-style1 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                                <div className="img-holder">
                                    <div className="inner">
                                        <img src="assets/images/blog/blog-v1-2.jpg" alt="" />
                                        <div className="date-box">
                                            <div className="shape-bg" style={{ backgroundImage: 'url(assets/images/shape/blog-shape-1.png)' }} />
                                            <h5>07 Dec</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-holder">
                                    <ul className="meta-info">
                                        <li><a>CONSULTANCY </a></li>
                                        <li><a>ADMIN</a></li>
                                    </ul>
                                    <h3 className="blog-title">
                                        <a href="blog-single.html">Understanding Layout & Building Approvals</a>
                                    </h3>
                                    <div className="text">
                                        <p>A simple guide to layout approvals, documentation, and regulatory
                                            requirements for smooth project execution.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*End Single blog Style1*/}
                        {/*Start Single blog Style1*/}
                        <div className="col-xl-4 col-lg-4">
                            <div className="single-blog-style1 wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                                <div className="img-holder">
                                    <div className="inner">
                                        <img src="assets/images/blog/blog-v1-3.jpg" alt="" />
                                        <div className="date-box">
                                            <div className="shape-bg" style={{ backgroundImage: 'url(assets/images/shape/blog-shape-1.png)' }} />
                                            <h5>07 Dec</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-holder">
                                    <ul className="meta-info">
                                        <li><a>PLANNING </a></li>
                                        <li><a>ADMIN</a></li>
                                    </ul>
                                    <h3 className="blog-title">
                                        <a href="blog-single.html">Benefits of Professional Construction Consultancy</a>
                                    </h3>
                                    <div className="text">
                                        <p>How expert planning, approvals support, and compliance management
                                            save time, cost, and effort.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*End Single blog Style1*/}
                    </div>
                </div>
            </section>
            {/*End Blog Style1 Area*/}




            {/* </div> */}

        </>
    )
}

export default Home;